import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import { paths } from 'src/paths';
import NotFound from 'src/pages/404';
import NotAuthorized from 'src/pages/401';
import ServerError from 'src/pages/500';
import Login from 'src/wrapper/login';
import ResetPassword from 'src/wrapper/reset-password';
import Register from 'src/wrapper/register';

import { useSections } from 'src/hooks/use-sections';
import { useRRoutes } from 'src/hooks/use-routes';
import AppLayout from './app-layout';
import { showLog } from 'src/utils/debug-log';

const AppRouter = (props) => {
  showLog('***** App-Router *****');
  
  const { isauthed } = props;
  const { rolecode } = useSections();
  const arrays = useRRoutes(rolecode, paths);
  return (
    <Router>
      <AppLayout areauthed={isauthed}>
        <Routes>
          <Route
            path={paths.index}
            element={<Navigate to={paths.dashboard.index} />}
          />

          <Route path={paths.notFound} element={<NotFound />} />
          <Route path={paths.notAuthorized} element={<NotAuthorized />} />
          <Route path={paths.serverError} element={<ServerError />} />
          <Route path={paths.myauth.index} element={<Login />} />
          <Route
            path={paths.myauth.resetPassword}
            element={<ResetPassword />}
          />
          <Route path={paths.auth.jwt.register} element={<Register />} />

          {generateDynamicRoutes(arrays)}

          <Route
            path="*"
            element={
              isauthed ? (
                <Navigate to={paths.notFound} />
              ) : (
                <Navigate to={paths.notAuthorized} />
              )
            }
          />
        </Routes>
      </AppLayout>
    </Router>
  );
};

const generateDynamicRoutes = (roles) => {
  return roles.map((route, index) => (
    <Route key={index} path={route.path} element={<route.component />} />
  ));
};

export default AppRouter;
